export const API_URL = process.env.REACT_APP_API_URL;
export const TRIPJACK_API_URL = process.env.REACT_APP_TRIPJACK_API_URL;